import {
  addRef,
  addState,
  addStateHandlers,
  flowMax,
  SimplePropsAdder,
} from 'ad-hok'
import { getContextHelpers, toObjectKeys } from 'ad-hok-utils'
import { MutableRefObject } from 'react'
import { typedAs } from 'shared/src/utils/typedAs'

interface FeedContext {
  visibleMediaId: number | null
  setVisibleMediaId: (id: number | null) => void
  isMuted: boolean
  toggleMuted: () => void
  isPlaying: boolean
  togglePlaying: () => void
  hasScrolledRef: MutableRefObject<boolean>
}

const [addFeedContextProviderInternal, addFeedContextInternal] =
  getContextHelpers<FeedContext>(
    toObjectKeys([
      'visibleMediaId',
      'setVisibleMediaId',
      'isMuted',
      'toggleMuted',
      'isPlaying',
      'togglePlaying',
      'hasScrolledRef',
    ])
  )

export const addFeedContext = addFeedContextInternal

type AddFeedContextProvider = SimplePropsAdder<FeedContext>

export const addFeedContextProvider: AddFeedContextProvider = flowMax(
  addState('visibleMediaId', 'setVisibleMediaId', typedAs<number | null>(null)),
  addStateHandlers(
    { isMuted: true, isPlaying: true },
    {
      toggleMuted:
        ({ isMuted }) =>
        () => ({
          isMuted: !isMuted,
        }),
      togglePlaying:
        ({ isPlaying }) =>
        () => ({
          isPlaying: !isPlaying,
        }),
    }
  ),
  addRef('hasScrolledRef', false),
  addFeedContextProviderInternal
)
